export default __webpack_public_path__ + "static/media/image-work-personal-m@2x.41fa1466.webp";